import { useCallback } from "react"
import api from "../services/api"

export const useDownloadPdf = () => {
  const downloadPdf = useCallback((token, planName = "plan") => {
    return api.getPlanPdf(token)
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement("a")
        link.href = url
        link.setAttribute("download", `${planName}.pdf`)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
  }, [])

  return { downloadPdf }
}
